var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Output, EventEmitter, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { DESIGNER_SETTINGS_SERVICE } from '../settings/designer-settings.service';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var ToolbarComponent = /** @class */ (function (_super) {
    __extends(ToolbarComponent, _super);
    function ToolbarComponent(injector, designerSettingsService) {
        var _this = _super.call(this, injector) || this;
        _this.designerSettingsService = designerSettingsService;
        _this.save = new EventEmitter();
        return _this;
    }
    ToolbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = new Subscription();
        this.subscription.add(this.designerSettingsService.isShowGridChange.subscribe(function (t) { return _this.isShowGrid = t; }));
        this.subscription.add(this.designerSettingsService.isGridSnapEnabledChange.subscribe(function (t) { return _this.isGridSnapEnabled = t; }));
        this.subscription.add(this.designerSettingsService.isGuidelineSnapEnabledChange.subscribe(function (t) { return _this.isGuidelineSnapEnabled = t; }));
    };
    ToolbarComponent.prototype.saves = function () {
        this.save.emit(undefined);
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    ToolbarComponent.prototype.deleteSelection = function () {
        if (this.commandHandler) {
            this.commandHandler.deleteSelection();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.cutSelection = function () {
        if (this.commandHandler) {
            this.commandHandler.cutSelection();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.copySelection = function () {
        if (this.commandHandler) {
            this.commandHandler.copySelection();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.pasteSelection = function () {
        if (this.commandHandler) {
            var isGridSnapEnabled = this.designerSettingsService.isGridSnapEnabled;
            var isGuidelineSnapEnabled = this.designerSettingsService.isGuidelineSnapEnabled;
            this.designerSettingsService.isGridSnapEnabled = false;
            this.designerSettingsService.isGuidelineSnapEnabled = false;
            this.commandHandler.pasteSelection();
            this.designerSettingsService.isGridSnapEnabled = isGridSnapEnabled;
            this.designerSettingsService.isGuidelineSnapEnabled = isGuidelineSnapEnabled;
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.undo = function () {
        if (this.commandHandler) {
            this.commandHandler.undo();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.redo = function () {
        if (this.commandHandler) {
            this.commandHandler.redo();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignLeft = function () {
        if (this.commandHandler) {
            this.commandHandler.alignLeft();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignCenterX = function () {
        if (this.commandHandler) {
            this.commandHandler.alignCenterX();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignRight = function () {
        if (this.commandHandler) {
            this.commandHandler.alignRight();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignTop = function () {
        if (this.commandHandler) {
            this.commandHandler.alignTop();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignCenterY = function () {
        if (this.commandHandler) {
            this.commandHandler.alignCenterY();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignBottom = function () {
        if (this.commandHandler) {
            this.commandHandler.alignBottom();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignRow = function () {
        if (this.commandHandler) {
            this.commandHandler.alignRow();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.alignColumn = function () {
        if (this.commandHandler) {
            this.commandHandler.alignColumn();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.bringToFront = function () {
        if (this.commandHandler) {
            this.commandHandler.bringToFront();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.sendToBack = function () {
        if (this.commandHandler) {
            this.commandHandler.sendToBack();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.bringForward = function () {
        if (this.commandHandler) {
            this.commandHandler.bringForward();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.sendBackward = function () {
        if (this.commandHandler) {
            this.commandHandler.sendBackward();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.lock = function () {
        if (this.commandHandler) {
            this.commandHandler.lock();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.unlock = function () {
        if (this.commandHandler) {
            this.commandHandler.unlock();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.showGallery = function () {
        this.galleryGlobalModal.show(this.commandHandler);
    };
    ToolbarComponent.prototype.toggleIsShowGrid = function () {
        this.designerSettingsService.isShowGrid = !this.isShowGrid;
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.toggleIsGridSnapEnabled = function () {
        this.designerSettingsService.isGridSnapEnabled = !this.isGridSnapEnabled;
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.toggleIsGuidelineSnapEnabled = function () {
        this.designerSettingsService.isGuidelineSnapEnabled = !this.isGuidelineSnapEnabled;
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.sameWidth = function () {
        if (this.commandHandler) {
            this.commandHandler.sameWidth();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.sameHeight = function () {
        if (this.commandHandler) {
            this.commandHandler.sameHeight();
            this.commandHandler.diagram.focus();
        }
    };
    ToolbarComponent.prototype.sameSize = function () {
        if (this.commandHandler) {
            this.commandHandler.sameSize();
            this.commandHandler.diagram.focus();
        }
    };
    __decorate([
        ViewChild('galleryGlobalModal', { static: false })
    ], ToolbarComponent.prototype, "galleryGlobalModal", void 0);
    __decorate([
        Input()
    ], ToolbarComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], ToolbarComponent.prototype, "commandHandler", void 0);
    __decorate([
        Output()
    ], ToolbarComponent.prototype, "save", void 0);
    ToolbarComponent = __decorate([
        Component({
            selector: 'configure-toolbar',
            template: "<div class='design-toolbar'> <div id=\"menuBar\" class=\"menuBar\"> <span> <a (click)=\"undo()\" class=\"revoke\" tooltip=\"{{lc('Undo')}}\"></a> <a (click)=\"redo()\" class=\"recovery\" tooltip=\"{{lc('Redo')}}\"></a> </span> <span> <a (click)=\"saves()\" class=\"save\" tooltip=\"{{lc('Save')}}\"></a> <a (click)=\"cutSelection()\" class=\"cut\" tooltip=\"{{lc('Cut')}}\"></a> <a (click)=\"copySelection()\" class=\"copy\" tooltip=\"{{lc('Copy')}}\"></a> <a (click)=\"pasteSelection()\" class=\"paste\" tooltip=\"{{lc('Paste')}}\"></a> <a (click)=\"deleteSelection()\" class=\"del\" tooltip=\"{{lc('Delete')}}\"></a> </span> <span> <a (click)=\"alignLeft()\" class=\"leftAlign\" tooltip=\"{{lc('AlignLeft')}}\"></a> <a (click)=\"alignCenterX()\" class=\"verticalAlign\" tooltip=\"{{lc('AlignVertical')}}\"></a> <a (click)=\"alignRight()\" class=\"rightAlign\" tooltip=\"{{lc('AlignRight')}}\"></a> <a (click)=\"alignTop()\" class=\"topAlign\" tooltip=\"{{lc('AlignTop')}}\"></a> <a (click)=\"alignCenterY()\" class=\"horizontalAlign\" tooltip=\"{{lc('AlignHorizontal')}}\"></a> <a (click)=\"alignBottom()\" class=\"bottomAlign\" tooltip=\"{{lc('AlignBottom')}}\"></a> <a (click)=\"alignRow()\" class=\"verticalSpacing\" tooltip=\"{{lc('AlignRow')}}\"></a> <a (click)=\"alignColumn()\" class=\"levelSpacing\" tooltip=\"{{lc('AlignColumn')}}\"></a> </span> <span> <span (click)=\"sameWidth()\" tooltip=\"{{lc('SameWidth')}}\" class=\"fcloud-same-width\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span> <span class=\"fcloud-same-height\" (click)=\"sameHeight()\" tooltip=\"{{lc('SameHeight')}}\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span></span> <span class=\"fcloud-same-size\" (click)=\"sameSize()\" tooltip=\"{{lc('SameSize')}}\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span><span class=\"path6\"></span><span class=\"path7\"></span></span> </span> <span> <a class=\"top\" (click)=\"bringToFront()\" tooltip=\"{{lc('BringToFront')}}\"></a> <a class=\"bottom\" (click)=\"sendToBack()\" tooltip=\"{{lc('SendToBack')}}\"></a> <a class=\"prev\" (click)=\"bringForward()\" tooltip=\"{{lc('BringForward')}}\"></a> <a class=\"next\" (click)=\"sendBackward()\" tooltip=\"{{lc('SendBackward')}}\"></a> </span> <zoom-settings [commandHandler]='commandHandler'></zoom-settings> <span> <a class=\"showGrid\" [class.active]=\"isShowGrid\" (click)=\"toggleIsShowGrid()\" tooltip=\"{{lc('ShowGrid')}}\"></a> <a class=\"gridSnap\" [class.active]=\"isShowGrid && isGridSnapEnabled\" [class.disabled]=\"!isShowGrid\" (click)=\"toggleIsGridSnapEnabled()\" tooltip=\"{{lc('GridSnap')}}\"></a> <a class=\"guidelineSnap\" [class.active]=\"isGuidelineSnapEnabled\" (click)=\"toggleIsGuidelineSnapEnabled()\" tooltip=\"{{lc('GuidelineSnap')}}\"></a> </span> <span> <a class=\"lock\" (click)=\"lock()\" tooltip=\"{{lc('Lock')}}\"></a> <a class=\"unlock\" (click)=\"unlock()\" tooltip=\"{{lc('Unlock')}}\"></a> </span> <span> <a class=\"graph\" (click)=\"showGallery()\" tooltip=\"{{lc('Gallery')}}\"></a> </span> </div> </div> <gallery-global-modal #galleryGlobalModal [configureId]=\"configureId\"></gallery-global-modal>",
            styles: [".design-toolbar{ @titleBackground: #f4f4f4; @titleHeight: 28px; @titlePadding: 0 10px; ul.windowUl { padding: 0; list-style: none; } .menuBar { padding: 4px 0; background-color: #fff; span { display: inline-block; padding: 0 5px; border-right: 1px solid #dddddd; a { vertical-align: sub; margin-right:5px; } } span:last-child { border: none; } .save { background-position: -40px -120px; } .save:hover { background-position: 0px -120px; } .revoke { background-position: -40px 0; } .revoke:hover { background-position: 0 0; } .recovery { background-position: -100px 0; } .recovery:hover { background-position: -60px 0; } .cut { background-position: -160px 0; } .cut:hover { background-position: -120px 0; } .copy { background-position: -220px 0; } .copy:hover { background-position: -180px 0; } .paste { background-position: -40px -20px; } .paste:hover { background-position: 0px -20px; } .del { background-position: -100px -20px; } .del:hover { background-position: -60px -20px; } .leftAlign { background-position: -160px -20px; } .leftAlign:hover { background-position: -120px -20px; } .verticalAlign { background-position: -220px -20px; } .verticalAlign:hover { background-position: -180px -20px; } .rightAlign { background-position: -40px -40px; } .rightAlign:hover { background-position: 0px -40px; } .topAlign { background-position: -100px -40px; } .topAlign:hover { background-position: -60px -40px; } .horizontalAlign { background-position: -160px -40px; } .horizontalAlign:hover { background-position: -120px -40px; } .bottomAlign { background-position: -220px -40px; } .bottomAlign:hover { background-position: -180px -40px; } .levelSpacing { background-position: -40px -60px; } .levelSpacing:hover { background-position: 0px -60px; } .verticalSpacing { background-position: -100px -60px; } .verticalSpacing:hover { background-position: -60px -60px; } .lock { background-position: -220px -140px; } .lock:hover { background-position: -180px -140px; } .unlock { background-position: -220px -160px; } .unlock:hover { background-position: -180px -160px; } .graph { background-position: -161px -140px; margin-bottom: 0 !important; } .graph:hover { background-position: -121px -140px; } .graph.active { background-position: -121px -140px; } .showGrid { background-position: -40px -160px; } .showGrid:hover { background-position: 0px -160px; } .showGrid.active { background-position: 0px -160px; } .gridSnap { background-position: -40px -180px; } .gridSnap:hover { background-position: 0px -180px; } .gridSnap.active { background-position: 0px -180px; } .gridSnap.disabled { pointer-events: none; background-position: -20px -180px; } .guidelineSnap { background-position: -40px -200px; } .guidelineSnap:hover { background-position: 0px -200px; } .guidelineSnap.active { background-position: 0px -200px; } .fcloud-same-width, .fcloud-same-height, .fcloud-same-size { font-size: 20px; background: none; border-right: none; cursor: pointer; margin-left: -7px; } .fcloud-same-width span, .fcloud-same-height span, .fcloud-same-size span { display: inline; padding: 0; border-right: none; position: relative; top: 2px; } } .menuBar span a, .screenTitle a { text-decoration: none; display: inline-block; height: 20px; cursor: pointer; width: 20px; background-image: url(\"/assets/common/images/configure/toolbar.png\"); } }"],
        }),
        __param(1, Inject(DESIGNER_SETTINGS_SERVICE))
    ], ToolbarComponent);
    return ToolbarComponent;
}(ConfigureComponentBase));
export { ToolbarComponent };
